module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/blue-e6b995cd904282948b805977b7248165.png";